import { useEffect, useState } from "react";
import { Building2, Save, X } from "lucide-react";
import { http, toastApiError } from "../../lib/api";
import { toast } from "../../lib/notify";
import { inp, lbl, btnDark, btnLight } from "./ledgerUtils";

const FIELDS = [["tax_office", "Vergi Dairesi", "örn. BÜYÜK MÜKELLEFLER"], ["tax_no", "Vergi Kimlik No", "10 hane"], ["mersis", "MERSİS No", "16 hane"], ["phone", "Telefon", "+90 …"], ["email", "E-posta", "muhasebe@…"], ["address", "Adres", "PDF antetinde görünür"],
  ["advisor_name", "Mali Müşavir", "Ad Soyad / Ünvan"], ["advisor_email", "Mali Müşavir E-posta", "Raporları 'E-posta' ile gönderirken alıcı olarak önerilir"]];

// Firma kimlik bilgileri (vergi dairesi / VKN / adres) — tüm muhasebe PDF antetlerinde kullanılır
export default function CompanyInfoDialog({ company, onClose }) {
  const [f, setF] = useState(null);
  const [busy, setBusy] = useState(false);
  useEffect(() => { http.get("/ledger/companies").then((r) => setF(r.data[company])).catch(toastApiError); }, [company]);
  useEffect(() => {
    const onKey = (e) => { if (e.key === "Escape") { e.stopImmediatePropagation(); onClose(); } };
    window.addEventListener("keydown", onKey, true);
    return () => window.removeEventListener("keydown", onKey, true);
  }, [onClose]);
  const save = async (e) => {
    e.preventDefault(); setBusy(true);
    try { await http.put("/ledger/companies", { ...f, company }); toast.success(`${company} firma bilgileri kaydedildi`); onClose(); } catch (err) { toastApiError(err); } finally { setBusy(false); }
  };
  return (
    <div className="fixed inset-0 z-50 bg-slate-900/50 flex items-start justify-center p-4 overflow-auto" onMouseDown={(e) => { if (e.target === e.currentTarget) onClose(); }} data-testid="company-info-dialog">
      <form onSubmit={save} className="bg-white rounded-lg shadow-2xl w-full max-w-2xl p-5 space-y-4 mt-10" role="dialog" aria-modal="true">
        <div className="flex items-center gap-2">
          <Building2 className="w-4 h-4 text-slate-700" /><span className="font-semibold text-sm">Firma Bilgileri — {company}</span>
          <span className="ml-auto text-[11px] text-slate-500">PDF antetlerinde (defterler, mizan, fişler) görünür · mali müşavir e-postası rapor gönderiminde alıcı · Esc kapatır</span>
        </div>
        {!f ? <div className="text-xs text-slate-400 py-6 text-center">Yükleniyor…</div> : (
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
            {FIELDS.map(([k, label, ph]) => (
              <label key={k} className={`${lbl} ${k === "address" ? "sm:col-span-2" : ""} ${k === "advisor_name" ? "pt-2 border-t border-slate-200 sm:col-span-1" : ""} ${k === "advisor_email" ? "pt-2 border-t border-slate-200" : ""}`}>{label}
                <input value={f[k] || ""} onChange={(e) => setF({ ...f, [k]: e.target.value })} placeholder={ph} className={`${inp} block w-full ${k === "tax_no" || k === "mersis" ? "font-mono" : ""}`} data-testid={`company-info-${k}`} />
              </label>))}
          </div>
        )}
        <div className="flex justify-end gap-2">
          <button type="button" onClick={onClose} className={btnLight} data-testid="company-info-cancel"><X className="w-3.5 h-3.5" /> İptal</button>
          <button type="submit" disabled={busy || !f} className={btnDark} data-testid="company-info-save"><Save className="w-3.5 h-3.5" /> Kaydet</button>
        </div>
      </form>
    </div>
  );
}
